"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var animable_object_1 = require("../../core/animable-object");
var __1 = require("../..");
var easing_functions_1 = require("../../core/easing-functions");
var text_cache_1 = require("../../core/text-cache");
var RenderTargetLabel = /** @class */ (function (_super) {
    __extends(RenderTargetLabel, _super);
    function RenderTargetLabel() {
        return _super.call(this) || this;
    }
    RenderTargetLabel.getRenderTargetLabel = function () {
        if (RenderTargetLabel.labelsPool.length > 0) {
            return RenderTargetLabel.labelsPool.pop();
        }
        else {
            return new RenderTargetLabel();
        }
    };
    RenderTargetLabel.labelsPool = [];
    return RenderTargetLabel;
}(animable_object_1.AnimableObject));
exports.RenderTargetLabel = RenderTargetLabel;
for (var i = 0; i < 50; i++) {
    RenderTargetLabel.labelsPool.push(new RenderTargetLabel());
}
var TelegramChartLabelsFeature = /** @class */ (function () {
    function TelegramChartLabelsFeature() {
        this.labelFontFamily = 'Helvetica';
        this.labelColor = '#8e8e93';
        this.xLabelWidth = 0;
        this.xLabelMargin = __1.TelegramChart.pixelsToCanvasSize(5);
        this.yLabelLineOffset = __1.TelegramChart.pixelsToCanvasSize(7);
        this.useTextCache = false;
        this.textCache = null;
        this.fontStyleCache = {};
        this.labelTextCache = [];
        this.xLabelsToKeep = [];
        this.yLabelsToKeep = [];
        this.labelVisibleFilterBound = this.labelVisibleFilter.bind(this);
        // Attention! 
        // Text cache doesn't work at all. Text is too small to have benefits of copying text from canvas over rendering it...
        if (this.useTextCache) {
            this.textCache = new text_cache_1.TextCache(this.getFontFillStyle(14), this.labelColor);
            var textToCache = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'k', 'M'].concat(__1.TelegramChart.monthNames);
            for (var i = 0; i < textToCache.length; i++) {
                this.textCache.createTextCacheEntry(textToCache[i]);
            }
        }
    }
    TelegramChartLabelsFeature.prototype.onDataChange = function () {
        if (this.renderTarget.viewPortScalePerY) {
            for (var _i = 0, _a = this.renderTarget.chart.getDataSets(this.renderTarget.chart.currentZoomState); _i < _a.length; _i++) {
                var ds = _a[_i];
                var viewPortDataFramePerY = this.renderTarget.viewPortDataFramePerY.get(this.renderTarget.chart.currentZoomState);
                this.onYMinMaxChange(viewPortDataFramePerY[ds.id].min, viewPortDataFramePerY[ds.id].max, ds.id);
            }
        }
        else {
            var viewPortDataFrame = this.renderTarget.viewPortDataFrame.get(this.renderTarget.chart.currentZoomState);
            this.onYMinMaxChange(viewPortDataFrame.y.min, viewPortDataFrame.y.max, null);
        }
    };
    TelegramChartLabelsFeature.prototype.onResize = function () {
        this.labelsCanvas.width = this.renderTarget.canvas.width;
        this.labelsCanvas.height = this.renderTarget.canvas.height;
        this.xLabelWidth = 0;
    };
    TelegramChartLabelsFeature.prototype.onAttach = function (renderTarget) {
        this.renderTarget = renderTarget;
        this.labelsCanvas = renderTarget.chart.document.createElement('canvas');
        this.labelsCanvas.width = renderTarget.canvas.width;
        this.labelsCanvas.height = renderTarget.canvas.height;
        this.labelsCanvas.className = 'labels-canvas';
        renderTarget.canvas.parentElement.appendChild(this.labelsCanvas);
        this.labelsCanvasContext = this.labelsCanvas.getContext('2d');
    };
    TelegramChartLabelsFeature.prototype.getFontFillStyle = function (size) {
        var style = this.fontStyleCache[size];
        if (style == null) {
            style = __1.TelegramChart.pixelsToCanvasSize(size) + "px " + this.labelFontFamily;
            this.fontStyleCache[size] = style;
        }
        return style;
    };
    TelegramChartLabelsFeature.prototype.animationRenderTargetLabelUpdate = function (o, child, v) { o.opacity = v; o.renderTarget.viewportChanged = true; };
    TelegramChartLabelsFeature.prototype.formatYLabelText = function (value) {
        var labelText = null;
        if (value >= 1000000) {
            labelText = (value / 1000000) + 'M';
        }
        else if (value >= 1000) {
            labelText = (Math.round((value / 1000) * 10) / 10) + 'k';
        }
        else {
            labelText = value.toString();
        }
        return labelText;
    };
    TelegramChartLabelsFeature.prototype.getXLabelFromValue = function (value) {
        var xStep = this.renderTarget.chart.currentZoomState.config.xStep;
        var stepArray = this.labelTextCache[xStep];
        if (stepArray == null) {
            this.labelTextCache[xStep] = [];
            stepArray = this.labelTextCache[xStep];
        }
        var label = stepArray[value];
        if (label == null) {
            var d = new Date(value);
            if (xStep == __1.TelegramChart.oneDayMilliseconds) {
                label = __1.TelegramChart.monthNames[d.getUTCMonth()] + " " + d.getUTCDate();
            }
            else if (xStep == __1.TelegramChart.oneHourMilliseconds) {
                label = d.getUTCHours() + ":00";
            }
            stepArray[value] = label;
        }
        return label;
    };
    TelegramChartLabelsFeature.prototype.calculateXLabels = function () {
        var t = this.renderTarget;
        this.xLabelsToKeep.length = 0;
        var viewPortDataFrame = t.viewPortDataFrame.get(t.chart.currentZoomState);
        if (viewPortDataFrame == null) {
            return;
        }
        var xStep = this.renderTarget.chart.currentZoomState.config.xStep;
        var visibleFrameSteps = (viewPortDataFrame.x.max - viewPortDataFrame.x.min) / xStep;
        visibleFrameSteps = Math.round(visibleFrameSteps);
        var visibleFrameInCanvasCoords = t.canvasWidth - t.viewPortPadding.left - t.viewPortPadding.right;
        var xMaxLabelsOnCanvas = visibleFrameInCanvasCoords / this.xLabelWidth;
        var xLineSpacingStepsRaw = visibleFrameSteps / xMaxLabelsOnCanvas;
        var xLineSpacingSteps = 1;
        while (xLineSpacingSteps < xLineSpacingStepsRaw) {
            xLineSpacingSteps *= 2;
        }
        if (xLineSpacingSteps == 0) {
            xLineSpacingSteps = 1;
        }
        var xLineSpacing = xLineSpacingSteps * xStep;
        var dataFrame = t.chart.dataFrame.get(t.chart.currentZoomState);
        var startFromStep = (dataFrame.x.max - viewPortDataFrame.x.max) / xStep;
        var startFromStepAdjusted = Math.ceil(startFromStep);
        while (startFromStepAdjusted % xLineSpacingSteps !== 0) {
            startFromStepAdjusted--;
        }
        var startFrom = dataFrame.x.max - (startFromStepAdjusted * xStep);
        var labelValue = startFrom + (xLineSpacing * 2);
        while (labelValue > viewPortDataFrame.x.min) {
            labelValue -= xLineSpacing;
            var animate = labelValue > viewPortDataFrame.x.min && labelValue < viewPortDataFrame.x.max;
            var label = this.addLabel(t, t.xLabels, labelValue, this.getXLabelFromValue(labelValue), 'x', animate);
            this.xLabelsToKeep.push(label);
        }
        t.xLabels = this.hideLabels(t.xLabels, this.xLabelsToKeep, 'x');
    };
    TelegramChartLabelsFeature.prototype.onYMinMaxChange = function (newYMin, newYMax, yId) {
        this.yLabelsToKeep.length = 0;
        if (this.renderTarget.yLabelsEnabled) {
            var yLines = 5;
            var yLineSpacing = (newYMax - newYMin) / yLines;
            for (var i = 0; i <= yLines; i++) {
                var labelValue = newYMin + (yLineSpacing * i);
                var label = this.addLabel(this.renderTarget, this.renderTarget.yLabels, labelValue, this.formatYLabelText(labelValue), yId);
                this.yLabelsToKeep.push(label);
            }
            this.renderTarget.yLabels = this.hideLabels(this.renderTarget.yLabels, this.yLabelsToKeep, yId);
        }
    };
    TelegramChartLabelsFeature.prototype.addLabel = function (renderTarget, allLabels, labelValue, labelText, yId, animate) {
        if (animate === void 0) { animate = true; }
        var chart = this.renderTarget.chart;
        var currentZoomLevelIndex = this.renderTarget.chart.currentZoomState.zoomLevelIndex;
        var label = null;
        // check whether we already have such label
        for (var l = 0; l < allLabels.length; l++) {
            var labelI = allLabels[l];
            if (labelI.value == labelValue
                && labelI.label == labelText
                && labelI.yId == yId
                && labelI.zoomLevelIndex == currentZoomLevelIndex) {
                label = labelI;
                break;
            }
        }
        var anim = null;
        if (label == null) {
            label = RenderTargetLabel.getRenderTargetLabel();
            label.value = labelValue;
            label.label = labelText;
            label.opacity = animate ? 0.0000001 : 1;
            label.renderTarget = renderTarget;
            label.yId = yId;
            label.zoomLevelIndex = currentZoomLevelIndex;
            allLabels.push(label);
            if (animate) {
                anim = chart.getAnimation();
                anim.duration = this.renderTarget.chart.animationTimeMs;
                this.renderTarget.chart.addAnimation(anim);
                label.animation = anim;
            }
        }
        else if (animate) {
            // if we already have a label we also want to look for it's animation since it may still exist and playing
            if (label.animation != null && label.animation.animatedObject == label && label.animation.finished == false) {
                anim = label.animation;
            }
            // if there is no animation but label is not new we have to create new animation for it
            if (anim == null && label.opacity == 0) {
                anim = this.renderTarget.chart.getAnimation();
                anim.duration = this.renderTarget.chart.animationTimeMs;
                this.renderTarget.chart.addAnimation(anim);
                label.animation = anim;
            }
        }
        if (anim != null) {
            anim.animatedObject = label;
            anim.easingFunction = easing_functions_1.EasingFunctions.linear;
            anim.startValue = label.opacity;
            anim.endValue = 1;
            anim.update = this.animationRenderTargetLabelUpdate;
            if (anim.endValue != 1) {
                anim.startTime = null;
            }
        }
        return label;
    };
    TelegramChartLabelsFeature.prototype.hideLabels = function (allLabels, labelsToKeep, yId) {
        if (yId === void 0) { yId = null; }
        var chart = this.renderTarget.chart;
        // go through all labels and check what labels can start fading out
        for (var i = 0; i < allLabels.length; i++) {
            var label = allLabels[i];
            if (yId != null && label.yId != yId) {
                continue;
            }
            var keep = false;
            for (var y = 0; y < labelsToKeep.length; y++) {
                if (label.value == labelsToKeep[y].value
                    && label.label == labelsToKeep[y].label
                    && label.yId == labelsToKeep[y].yId
                    && label.zoomLevelIndex == chart.currentZoomState.zoomLevelIndex) {
                    keep = true;
                    break;
                }
            }
            if (!keep && label.opacity > 0) { // if label has to be removed but is still visible
                var anim = null;
                // check whether there is a hiding animation in progress
                if (label.animation != null && label.animation.animatedObject == label && label.animation.finished == false) {
                    anim = label.animation;
                }
                if (anim == null) {
                    anim = chart.getAnimation();
                    anim.tag = label.value;
                    anim.animatedObject = label;
                    anim.duration = chart.animationTimeMs;
                    anim.easingFunction = easing_functions_1.EasingFunctions.easeOutQuad;
                    anim.startValue = label.opacity;
                    anim.endValue = 0;
                    anim.update = this.animationRenderTargetLabelUpdate;
                    chart.addAnimation(anim);
                    label.animation = anim;
                }
                else if (anim.endValue != 0) {
                    anim.startValue = label.opacity;
                    anim.endValue = 0;
                    anim.startTime = null;
                }
            }
        }
        return allLabels.filter(this.labelVisibleFilterBound);
    };
    TelegramChartLabelsFeature.prototype.labelVisibleFilter = function (l) {
        if (l.opacity <= 0) {
            RenderTargetLabel.labelsPool.push(l);
            return false;
        }
        return true;
    };
    TelegramChartLabelsFeature.prototype.renderBackground = function () {
        this.labelsCanvasContext.clearRect(0, 0, this.renderTarget.canvasWidth, this.renderTarget.canvasHeight);
        if (this.xLabelWidth == 0) {
            this.labelsCanvasContext.font = this.getFontFillStyle(10);
            var textDimensions = this.labelsCanvasContext.measureText("XXX 00");
            this.xLabelWidth = textDimensions.width + (this.xLabelMargin * 2);
        }
        if (this.renderTarget.yLabelsEnabled) {
            this.renderTarget.yLabels = this.renderTarget.yLabels.filter(this.labelVisibleFilterBound);
            this.renderTarget.canvasContext.strokeStyle = this.renderTarget.chart.lineColor;
            for (var i = 0; i < this.renderTarget.yLabels.length; i++) {
                var labelPositionY = this.renderTarget.chart.yValueToCanvasPosition(this.renderTarget.yLabels[i].value, this.renderTarget, this.renderTarget.chart.currentZoomState, this.renderTarget.viewPortPadding.top, this.renderTarget.viewPortPadding.bottom, this.renderTarget.viewPortScalePerY ? this.renderTarget.yLabels[i].yId : null);
                this.renderTarget.canvasContext.globalAlpha = this.renderTarget.yLabels[i].opacity;
                this.renderTarget.canvasContext.beginPath();
                this.renderTarget.canvasContext.lineWidth = __1.TelegramChart.pixelsToCanvasSize(1);
                this.renderTarget.canvasContext.moveTo(this.renderTarget.viewPortPadding.left, labelPositionY);
                this.renderTarget.canvasContext.lineTo(this.renderTarget.canvasWidth - this.renderTarget.viewPortPadding.right, labelPositionY);
                this.renderTarget.canvasContext.stroke();
            }
        }
        if (this.renderTarget.xLabelsEnabled) {
            this.calculateXLabels();
            this.labelsCanvasContext.textAlign = 'end';
            if (!this.useTextCache) {
                this.labelsCanvasContext.fillStyle = this.labelColor;
            }
            for (var i = 0; i < this.renderTarget.xLabels.length; i++) {
                this.labelsCanvasContext.globalAlpha = this.renderTarget.xLabels[i].opacity;
                var labelPositionX = this.renderTarget.chart.xValueToCanvasPosition(this.renderTarget.xLabels[i].value, this.renderTarget, this.renderTarget.chart.currentZoomState, this.renderTarget.viewPortPadding.left, this.renderTarget.viewPortPadding.right);
                if (this.useTextCache) {
                    this.textCache.drawTextCacheEntry(this.labelsCanvasContext, labelPositionX, this.renderTarget.canvas.height - __1.TelegramChart.pixelsToCanvasSize(25), this.renderTarget.xLabels[i].label);
                }
                else {
                    this.labelsCanvasContext.fillText(this.renderTarget.xLabels[i].label, labelPositionX, this.renderTarget.canvas.height - __1.TelegramChart.pixelsToCanvasSize(11));
                }
            }
        }
    };
    TelegramChartLabelsFeature.prototype.renderForeground = function () {
        this.labelsCanvasContext.fillStyle = this.labelColor;
        if (this.renderTarget.yLabelsEnabled) {
            for (var i = 0; i < this.renderTarget.yLabels.length; i++) {
                var label = this.renderTarget.yLabels[i];
                var labelPositionY = this.renderTarget.chart.yValueToCanvasPosition(label.value, this.renderTarget, this.renderTarget.chart.currentZoomState, this.renderTarget.viewPortPadding.top, this.renderTarget.viewPortPadding.bottom, label.yId);
                labelPositionY -= this.yLabelLineOffset;
                var labelPositionX = this.renderTarget.viewPortPadding.left;
                if (this.renderTarget.viewPortScalePerY) {
                    this.labelsCanvasContext.fillStyle = this.renderTarget.chart.getLineColorById(this.renderTarget.yLabels[i].yId, this.renderTarget.chart.currentZoomState);
                }
                else {
                    this.labelsCanvasContext.fillStyle = this.labelColor;
                }
                if (this.renderTarget.viewPortScalePerY && this.renderTarget.yLabels[i].yId == 'y1') {
                    labelPositionX = this.renderTarget.canvasWidth - this.renderTarget.viewPortPadding.right;
                    this.labelsCanvasContext.textAlign = 'end';
                }
                else {
                    this.labelsCanvasContext.textAlign = 'start';
                }
                this.labelsCanvasContext.globalAlpha = label.opacity;
                if (label.yId != null) {
                    this.labelsCanvasContext.globalAlpha *= this.renderTarget.yOpacity[label.yId];
                }
                if (this.useTextCache) {
                    this.textCache.drawTextCacheEntry(this.labelsCanvasContext, labelPositionX, labelPositionY, this.renderTarget.yLabels[i].label);
                }
                else {
                    this.labelsCanvasContext.fillText(this.renderTarget.yLabels[i].label, labelPositionX, labelPositionY);
                }
            }
        }
    };
    return TelegramChartLabelsFeature;
}());
exports.TelegramChartLabelsFeature = TelegramChartLabelsFeature;
//# sourceMappingURL=labels.js.map